<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品管理
      <small>
        /&nbsp;
        <router-link to="/goodslist" class="TitleStyle">商品列表</router-link>
        /&nbsp;新增商品
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">新增商品</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">商品信息</span>
                  </div>
                  <div class="GContent">
                    <el-form
                      :model="ruleForm"
                      :inline="true"
                      :rules="rules"
                      ref="ruleForm"
                      label-width="150px"
                      class="demo-form-inline"
                    >
                      <el-form-item label="原产国:" prop="placeOfOriginCode" class="labelstyle">
                        <el-select
                          v-model="ruleForm.placeOfOriginCode"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="item in CountryList"
                            :key="item.baseId"
                            :label="item.baseName"
                            :value="item.baseId"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="品牌名称:" prop="brandId" class="labelstyle">
                        <el-select
                          filterable
                          v-model="ruleForm.brandId"

                          placeholder="请选择"
                          @change="brandChange"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in brandList"
                            :key="item.brandId"
                            :label="item.brandName"
                            :value="item.brandId"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="品牌系列:" prop="seriesId" class="labelstyle">
                        <el-select
                          filterable
                          v-model="ruleForm.seriesId"
                          placeholder="请选择"


                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in SeriesList"
                            :key="item.seriesId"
                            :label="item.seriesName"
                            :value="item.seriesId"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="商品编号:" prop="goodsCode" class="labelstyle">
                        <el-input v-model="ruleForm.goodsCode" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="商品名称:" prop="goodsName" class="labelstyle">
                        <el-input v-model="ruleForm.goodsName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="条形码:" prop="barCode" class="labelstyle">
                        <el-input v-model="ruleForm.barCode" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="是否含税:" prop="isTax" class="labelstyle">
                        <el-select
                          disabled
                          v-model="Taxs"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="税率:" prop="taxrate" class="labelstyle">
                        <el-input
                          disabled
                          v-model="Taxsrate"
                          class="DistributorMargin InputWidth"

                        ></el-input>
                      </el-form-item>
                      <el-form-item label="可售数量:" prop="reserve" class="labelstyle">
                        <el-input
                          v-model.number="ruleForm.reserve"
                          class="DistributorMargin InputWidth"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="单位:" prop="unit" class="labelstyle">
                        <el-select
                          v-model="ruleForm.unit"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          filterable

                        >
                          <el-option
                            v-for="item in unitList"
                            :key="item.baseName"
                            :label="item.baseName"
                            :value="item.baseName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="商品规格:" prop="specs" class="labelstyle">
                        <el-input v-model="ruleForm.specs" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="描述:" prop="categoryChange" class="labelstyle">
                        <el-input v-model="ruleForm.description" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>

                      <el-form-item label="毛重:" prop="weight" class="labelstyle">
                        <el-input v-model="ruleForm.weight" class="DistributorMargin InputWidth"
                                  style="width:250px;"></el-input>
                        <span style="display:inline-block;width:50px">kg</span>
                      </el-form-item>
                      <el-form-item label="净重:" prop="netWeight" class="labelstyle">
                        <el-input v-model="ruleForm.netWeight" class="DistributorMargin InputWidth"
                                  style="width:250px;"></el-input>
                        <span style="display:inline-block;width:50px">kg</span>
                      </el-form-item>
                      <el-form-item label="电脑版支付商户号:" prop="pcMerchantCode" class="labelstyle">
                        <el-select
                          v-model="ruleForm.pcMerchantCode"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          filterable
                          @change="(val) => {
                              if (val) {
                                $set(ruleForm, 'pcStmMerchantCode', PayConfigList.find(el => el.payCode === val).ppayCode)
                              } else {
                                $set(ruleForm, 'pcStmMerchantCode', undefined)
                              }
                            }"
                        >
                          <el-option
                            v-for="item in PayConfigList.filter(el => el.isPc)"
                            :key="item.id"
                            :label='item.remark'
                            :value='item.payCode'
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="手机版支付商户号:" prop="ydMerchantCode" class="labelstyle">
                        <el-select
                          v-model="ruleForm.ydMerchantCode"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          filterable
                          @change="(val) => {
                              if (val) {
                                $set(ruleForm, 'ydStmMerchantCode', PayConfigList.find(el => el.payCode === val).ppayCode)
                              } else {
                                $set(ruleForm, 'ydStmMerchantCode', undefined)
                              }
                            }"
                        >
                          <el-option
                            v-for="item in PayConfigList.filter(el => !el.isPc)"
                            :key="item.id"
                            :label='item.remark'
                            :value='item.payCode'
                          ></el-option>
                        </el-select>
                      </el-form-item>


                      <div class="clear"></div>
                    </el-form>
                    <div style="height:46px;padding-top:16px;text-align:right;">
                      <button
                        class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                        style="margin-right:16px"
                        @click="MakeSure('ruleForm')"
                        :disabled="disabled"
                      >确定
                      </button>
                      <a
                        class="swal-button swal-button--cancel btn btn-default"
                        @click="GoBack"

                      >取消</a>

                      <span class="clear"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="OrderInfo" style="margin-top:32px" v-if="DetailShow">
                <div class="GTitle">
                  <span class="TInfo">商品图片</span>
                </div>
                <div class="GContent">
                  <el-form
                    :model="ruleFormpictrue"
                    :rules="rulespictrue"
                    ref="ruleFormpictrue"
                    label-width="150px"
                  >
                    <el-form-item label="上传商品图：">
                      <el-upload
                        class="avatar-uploader DistributorMargin InputWidth"
                        action
                        :show-file-list="false"
                        :http-request="handleAvatarSuccess"
                      >
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <a class="clear"></a>
                    </el-form-item>
                    <div class="clear"></div>

                    <el-form-item label="商品图展示:">
                      <ul style="margin-left:25px;">
                        <li
                          v-for="(item,index) in imgArr"
                          :key="index"
                          class="imgArrLi"
                          @mouseenter="MouseEnterImg(item,index)"
                          @mouseleave="MouseLeaveImg(item,index)"
                        >
                          <img
                            src="@/assets/Close.svg"
                            style="position:absolute;width:16px;right:0px;top:10px;"
                            v-if="item.CloseShow"
                            @click="CloseGoodsImg(item,index)"
                          >
                          <el-radio
                            v-model="radio"
                            :label="index"
                            @change="MainChange"
                            style="float:left;"
                          >
                            <img :src="item.data" style="margin-left:16px;width:200px;height:150px">
                          </el-radio>
                        </li>

                        <li class="clear"></li>
                      </ul>
                    </el-form-item>

                    <div class="clear"></div>
                  </el-form>
                  <div style="height:46px;padding-top:16px;text-align:right;">
                    <a
                      class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                      @click="MakeSurePictrue('ruleFormpictrue')" style="margin-right:16px"
                    >确定</a>
                    <a
                      class="swal-button swal-button--cancel btn btn-default"
                      @click="GoBack"

                    >取消</a>

                    <span class="clear"></span>
                  </div>
                </div>
              </div>
              <div class="OrderInfo" style="margin-top:32px" v-if="DetailShow">
                <div class="GTitle">
                  <span class="TInfo">商品详情</span>
                </div>
                <div class="GContent">
                  <el-form :model="ruleData" :rules="ruledatas" ref="ruleData" label-width="150px">
                    <el-form-item label="上传详情图:">
                      <el-upload
                        class="avatar-uploader DistributorMargin InputWidth"
                        action
                        :show-file-list="false"
                        :http-request="secondhandleAvatarSuccess"
                      >
                        <img v-if="secondimageUrl" :src="secondimageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <a
                        class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                        style="float:right"
                        @click="AddDetail"
                        v-if="secondimgArr.length !== 0"
                      >添加权重和描述</a>

                      <a class="clear"></a>
                    </el-form-item>
                    <div class="clear"></div>
                    <el-form-item label="详情图展示:" prop>
                      <ul style="margin-left:25px;">
                        <li
                          v-for="(item,index) in secondimgArr"
                          :key="index"
                          class="imgArrLi"
                          @mouseenter="MouseEnterDetailImg(item,index)"
                          @mouseleave="MouseLeaveDetailImg(item,index)"
                        >
                          <img
                            src="@/assets/Close.svg"
                            style="position:absolute;width:16px;right:0px;top:10px;"
                            v-if="item.CloseShow"
                            @click="CloseGoodsDetailImg(item,index)"
                          >
                          <img :src="item.data" style="margin-left:16px;width:200px;">
                          <div v-if="item.detailShow">
                            <div>
                              权重：
                              <el-input
                                v-model="item.weights"
                                style="width:150px;margin-bottom:16px;"
                              ></el-input>
                            </div>
                            <div>
                              描述：
                              <el-input v-model="item.description" style="width:150px"></el-input>
                            </div>
                          </div>
                        </li>

                        <li class="clear"></li>
                      </ul>
                    </el-form-item>
                  </el-form>
                  <div style="height:46px;padding-top:16px;text-align:right;">
                    <a
                      class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                      @click="MakeSureDetail('ruleData')" style="margin-right:16px"
                    >确定</a>
                    <a
                      class="swal-button swal-button--cancel btn btn-default"
                      @click="GoBack"

                    >取消</a>

                    <span class="clear"></span>
                  </div>
                </div>
              </div>
              <div class="OrderInfo" style="margin-top:32px" v-if="DetailShow">
                <div class="GTitle">
                  <span class="TInfo">商品属性</span>
                </div>
                <div class="GContent">
                  <form class="MarginTop">
                    <fieldset>
                      <ul style="margin-bottom:0rem" v-if="TableContents.length !== 0">
                        <li class="ReceiptTableTitle">属性编码</li>
                        <li class="ReceiptTableTitle">属性名称</li>
                        <li class="ReceiptTableTitle">属性值</li>
                        <li class="ReceiptTableTitle">单位</li>
                        <li class="ReceiptTableTitle" style="width:200px">操作</li>

                        <li class="clear"></li>
                      </ul>
                      <ul
                        v-for="(item,index) in TableContents"
                        :key="index"
                        style="margin-bottom:0px;"
                      >
                        <li class="ReceiptTableContent">{{ item.proCode }}</li>
                        <li class="ReceiptTableContent">{{ item.proName }}</li>
                        <li class="ReceiptTableContent">{{ item.proValue }}</li>
                        <li class="ReceiptTableContent">{{ item.proUnit }}</li>
                        <li class="ReceiptTableContent" style="width:200px;">
                          <a
                            class="btn btn-warning btn-sm ButtonColor"
                            @click="DeleteAttribute(item,index)"
                          >删除</a>
                        </li>

                        <li class="clear"></li>
                      </ul>
                      <div class="form-group row m-b-15">
                        <div class="col-md-11"></div>
                        <div class="col-md-1">
                          <a
                            class="btn btn-primary m-r-5 ButtonColor"
                            @click="AddGoods"
                            style="float:right;margin-top:16px;"
                          >添加</a>
                        </div>

                        <div class="form-group row m-b-15"></div>
                      </div>
                    </fieldset>
                  </form>

                  <ul style="margin-bottom:0rem">
                    <li class="ReceiptTableTitle" style="padding: 12px 48px;"><span
                      style="color:red;position:absolute;left: 36px;top: 14px;">*</span>属性编码
                    </li>
                    <li class="ReceiptTableTitle" style="padding: 12px 48px;"><span
                      style="color:red;position:absolute;left: 36px;top: 14px;">*</span>属性名称
                    </li>
                    <li class="ReceiptTableTitle" style="padding: 12px 48px;"><span
                      style="color:red;position:absolute;left: 36px;top: 14px;">*</span>属性值
                    </li>
                    <li class="ReceiptTableTitle">单位</li>
                    <li class="ReceiptTableTitle" style="width:200px">操作</li>
                    <li class="clear"></li>
                  </ul>

                  <ul v-for="(item,index) in TableContent" :key="index">
                    <li class="ReceiptTableContent">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="属性编码"
                        v-model="item.proCode"
                        :disabled="item.disabled"
                      >
                      <div class="EorrorTips" v-if="item.proCodeShow">请输入属性编码</div>
                    </li>
                    <li class="ReceiptTableContent">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="属性名称"
                        v-model="item.proName"
                        :disabled="item.disabled"
                      >
                      <div class="EorrorTips" v-if="item.proNameShow">请输入属性名称</div>
                    </li>
                    <li class="ReceiptTableContent">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="属性值"
                        v-model="item.proValue"
                        :disabled="item.disabled"
                      >
                      <div class="EorrorTips" v-if="item.proValueShow">请输入属性值</div>
                    </li>
                    <li class="ReceiptTableContent">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="单位"
                        v-model="item.proUnit"
                        :disabled="item.disabled"
                      >
                    </li>
                    <li class="ReceiptTableContent" style="width:200px;">

                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="MakeSureAttribute(item,index)"
                      >确定</a>
                      <a
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(item,index)"
                      >删除</a>
                    </li>
                    <li class="clear"></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">
      <div class="ModelPadding" v-if="EditDialog === 1">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将此图设为主图!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSet">确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button swal-button--confirm btn btn-primary" @click="MakeSureDelete">确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "InventoryDetailList",
  data() {
    var checkgoodsCode = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length < 8 || value.length > 16) {
          callback(new Error("商品编号必须8-16位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkReserve = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("必须大于0"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    var checktaxrate = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^[0-1]$|^0\.[0-9]+$/;
        if (!reg.test(value) && this.ruleForm.isTax === 1) {
          callback(new Error("必须大于0小于1"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkgoodsName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("商品名称不能超过32位"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      goodsId: "",
      radio: "",
      unitList: [],
      brandList: [],
      SeriesList: [],
      CountryList: [],
      ruleForm: {},
      Taxs: 0,
      Taxsrate: 0.091,
      outerVisible: false,
      EditDialog: 1,
      MakeSureShow: false,
      imgArr: [],
      pageSize: 10,
      pageIndex: 1,
      rules: {
        goodsCode: [
          {required: true, message: "请输入商品编号", trigger: "blur"},
          {validator: checkgoodsCode, trigger: "blur"}
        ],
        unit: [{required: true, message: "请输入单位", trigger: "blur"}],
        goodsName: [
          {required: true, message: "请输入商品名称", trigger: "blur"},
          {validator: checkgoodsName, trigger: "blur"}
        ],
        categoryId: [
          {required: true, message: "请选择分类", trigger: "blur"}
        ],
        brandId: [{required: true, message: "请选择品牌", trigger: "blur"}],
        seriesId: [{required: true, message: "请选择系列", trigger: "blur"}],
        reserve: [
          {required: true, message: "请输入库存数", trigger: "blur"},
          {validator: checkReserve, trigger: "blur"}
        ],
        placeOfOriginCode: [
          {required: true, message: "请选择原产国", trigger: "blur"}
        ],
        pcMerchantCode: [
          {required: true, message: "请选择支付商户号", trigger: "blur"}
        ],
        ydMerchantCode: [
          {required: true, message: "请选择支付商户号", trigger: "blur"}
        ]
      },
      goodsId: "",
      ruleFormpictrue: {},
      rulespictrue: {},
      ruleData: {},
      ruledatas: {
        weights: [{required: true, message: '请输入权重', trigger: 'blur'}]
      },
      TableContents: [],
      secondimgArr: [],
      disabled: false,
      DetailShow: false,
      brandDisabled: true,
      seriesDisabled: true,
      value: '',
      brand: '',
      selectAttrbute: [],
      series: '',
      imageUrl: '',
      secondimageUrl: '',
      TableContent: [],
      options: [
        {
          value: 1,
          label: '否'
        },
        {
          value: 0,
          label: '是'
        }
      ],
      companyId: '',
      PayConfigList: []
    };
  },
  mounted: function () {
    if (localStorage.getItem('goodlist')) {
      let goodlist = localStorage.getItem('goodlist')
      this.pageIndex = JSON.parse(goodlist).pageIndex
      this.pageSize = JSON.parse(goodlist).pageSize
    }
    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId
    }
    this.initCountry()
    this.initUnitList()
    this.initbrandInfo()
    this.getPayConfigList()
  },
  methods: {
    getPayConfigList() {
      let that = this
      const options = {
        url: 'pay/payConfig/getPayConfigList',
        method: 'get'
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.PayConfigList = response.data.data
          } else {
            that.$notify({
              title: '失败',
              message: response.data.message,
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that)
        })
    },
    initCountry() {
      let that = this;
      const options = {
        url: "distribution/B2cDictController/queryCountry",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({})
      };
      axios(options)
        .then(function (response) {
          if (response.data.code == 200) {
            that.CountryList = response.data.data;
          } else {
            that.$notify({
              title: "失败",
              message: response.data.message,
              type: "error"
            });
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    initUnitList() {
      let that = this;

      const options = {
        url: "distribution/B2cDictController/queryUnit",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({})
      };
      axios(options)
        .then(function (response) {
          if (response.data.code == 200) {
            that.unitList = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    initbrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/brandAndSer",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({
          companyId: that.companyId
        })
      };
      axios(options)
        .then(function (response) {
          if (response.data.code == 200) {
            that.brandList = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    brandChange(val) {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({
          brandId: val
        })
      };
      axios(options)
        .then(function (response) {
          if (response.data.code == 200) {
            that.SeriesList = response.data.data;
            if (that.ruleForm.seriesId) {
              that.ruleForm.seriesId = "";
            }
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },

    MainChange() {
    },
    MouseEnterImg(item, index) {
      this.imgArr.forEach((val, index2) => {
        if (index2 === index) {
          val.CloseShow = true;
        } else {
          val.CloseShow = false;
        }
        this.$set(this.imgArr, index, item);
      });
    },
    MouseLeaveImg(item, index) {
      item.CloseShow = false;

      this.$set(this.imgArr, index, item);
    },
    CloseGoodsImg(item, index) {
      let that = this;
      let arr = [];
      this.imgArr.forEach((val, index2) => {
        if (index2 !== index) {
          arr.push(val);
        }
      });

      this.imgArr = arr;
    },
    MouseEnterDetailImg(item, index) {
      this.secondimgArr.forEach((val, index2) => {
        if (index2 === index) {
          val.CloseShow = true;
        } else {
          val.CloseShow = false;
        }
        this.$set(this.secondimgArr, index, item);
      });
    },
    MouseLeaveDetailImg(item, index) {
      item.CloseShow = false;

      this.$set(this.secondimgArr, index, item);
    },
    CloseGoodsDetailImg(item, index) {
      let that = this;
      let arr = [];
      this.secondimgArr.forEach((val, index2) => {
        if (index2 !== index) {
          arr.push(val);
        }
      });

      this.secondimgArr = arr;
    },
    AddDetail() {
      this.secondimgArr.forEach((val, index) => {
        val.detailShow = true;

        this.$set(this.secondimgArr, index, val);
      });
    },
    MakeSet() {
      this.outerVisible = false;
      this.EditDialog = 1;
      this.MakeSureShow = true;
    },
    SetMain() {
      if (this.radio !== "") {
        this.outerVisible = true;
      } else {
        this.$notify({
          title: "失败",
          message: "请先选择一张图片",
          type: "error"
        });
      }
    },
    DeleteAttribute(item, index) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.selectAttrbute = item;
    },
    MakeSureDelete() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsPropertiesController/delGoodsProperties",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({
          proId: that.selectAttrbute.proId
        })
      };
      axios(options)
        .then(function (response) {
          that.outerVisible = false;
          if (response.data.code == 200) {
            that.InitProperties();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    MakeSure(formName) {
      let that = this;
      let taxrate = 0
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.disabled = true;
          const options = {
            url: "distribution/B2cGoodsInfoController/addGoodsInfo",
            method: "post",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: Qs.stringify({
              companyId: that.companyId,
              goodsCode: that.ruleForm.goodsCode,
              goodsName: that.ruleForm.goodsName.replace(/\s+/g, ''),
              unit: that.ruleForm.unit,
              categoryId: that.ruleForm.categoryId,
              brandId: that.ruleForm.brandId,
              seriesId: that.ruleForm.seriesId,
              reserve: that.ruleForm.reserve,
              isTax: that.Taxs,
              taxrate: that.Taxsrate,
              placeOfOriginCode: that.ruleForm.placeOfOriginCode,
              specs: that.ruleForm.specs,
              weight: that.ruleForm.weight,
              netWeight: that.ruleForm.netWeight,
              barCode: that.ruleForm.barCode,
              description: that.ruleForm.description,
              pcMerchantCode: that.ruleForm.pcMerchantCode,
              ydMerchantCode: that.ruleForm.ydMerchantCode,
              pcStmMerchantCode: that.ruleForm.pcStmMerchantCode,
              ydStmMerchantCode: that.ruleForm.ydStmMerchantCode
            })
          };
          axios(options)
            .then(function (response) {
              that.disabled = false;
              if (response.data.code == 200) {
                that.DetailShow = true;
                that.imageUrl = "";
                that.secondimgUrl = "";
                that.TableContent = [];
                that.TableContents = [];
                that.goodsId = response.data.data.goodsId;
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function (error) {
              that.disabled = false;
              http.handleHttpError(error, that);
            });
        }
      });
    },
    InitProperties() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/queryOneGoodProperties",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({
          goodsId: that.goodsId
        })
      };
      axios(options)
        .then(function (response) {
          if (response.data.code == 200) {
            that.TableContents = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    MakeSurePictrue(formName) {
      let that = this;
      let b2cGoodsPicUrlFormList = [];

      if (
        this.radio !== "" &&
        this.radio < this.imgArr.length
      ) {
        this.imgArr.forEach((element, index) => {
          if (index === this.radio) {
            element.isMain = 1;
          } else {
            element.isMain = 0;
          }
          b2cGoodsPicUrlFormList.push({
            address: element.data,
            isMain: element.isMain
          });
        });
        if (b2cGoodsPicUrlFormList.length == 0) {
          that.$notify({
            title: "警告",
            message: "请上传图片",
            type: "warning"
          });
          return;
        }
        that.$refs[formName].validate(valid => {
          if (valid) {
            const options = {
              url: "distribution/B2cGoodsFilesController/addGoodsFiles",
              method: "post",
              headers: {"Content-Type": "application/json"},
              data: {
                goodsId: that.goodsId,
                b2cGoodsPicUrlFormList: b2cGoodsPicUrlFormList,
              }
            };
            axios(options)
              .then(function (response) {
                if (response.data.code == 200) {
                  that.DetailShow = true;
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function (error) {
                http.handleHttpError(error, that);
              });
          }
        });
      } else {
        that.$notify({
          title: "失败",
          message: "请先设置一张主图",
          type: "error"
        });
      }
    },
    MakeSureDetail(formName) {
      let that = this;
      let b2cGoodsDetailPicUrlForms = [];
      let arr = [];
      that.secondimgArr.forEach((element, index) => {
        if (!element.detailShow) {
          element.weights = index + 1;
        } else if (element.detailShow) {
          arr.push(element.weights);
        }
      });
      //不存在
      if (arr.indexOf("") == -1) {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.secondimgArr.forEach(element => {
              b2cGoodsDetailPicUrlForms.push({
                weights: Number(element.weights),
                imageUrl: element.data,
                description: element.description
              });
            });
            if (b2cGoodsDetailPicUrlForms.length == 0) {
              that.$notify({
                title: "警告",
                message: "请上传图片",
                type: "warning"
              });
              return;
            }
            const options = {
              url: "distribution/B2cGoodsDetailInfoController/addGoodsDetail",
              method: "post",
              headers: {"Content-Type": "application/json"},
              data: {
                goodsId: that.goodsId,
                b2cGoodsDetailPicUrlForms: b2cGoodsDetailPicUrlForms,
              }
            };
            axios(options)
              .then(function (response) {
                if (response.data.code == 200) {
                  that.DetailShow = true;
                  that.imageUrl = "";
                  that.secondimgUrl = "";
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function (error) {
                http.handleHttpError(error, that);
              });
          }
        });
      } else {
        that.$notify({
          title: "失败",
          message: "权重不能为空",
          type: "error"
        });
      }
    },
    CheckError(item, index) {
      if (!item.proCode) {
        item.proCodeShow = true;
      } else {
        item.proCodeShow = false;
      }
      if (!item.proName) {
        item.proNameShow = true;
      } else {
        item.proNameShow = false;
      }
      if (!item.proValue) {
        item.proValueShow = true;
      } else {
        item.proValueShow = false;
      }
      this.$set(this.TableContent, index, item);
    },
    MakeSureAttribute(item, index) {
      this.CheckError(item, index);
      let that = this;
      if (!item.proCodeShow && !item.proNameShow && !item.proValueShow) {
        const options = {
          url: "distribution/B2cGoodsPropertiesController/addGoodsProperties",
          method: "post",
          headers: {"Content-Type": "application/x-www-form-urlencoded"},
          data: Qs.stringify({
            goodsId: that.goodsId,
            proCode: item.proCode,
            proName: item.proName,
            proUnit: item.proUnit,
            proValue: item.proValue
          })
        };
        axios(options)
          .then(function (response) {
            if (response.data.code == 200) {
              that.InitProperties();
              //  that.TableContents.push(item)
              that.TableContent = [];
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function (error) {
            http.handleHttpError(error, that);
          });
      }
    },
    AddGoods() {
      let arr = {};
      arr.disabled = false;
      this.TableContent.push(arr);
    },
    DeleteClick(item, index) {
      this.TableContent.forEach((val, index1) => {
        if (index === index1) {
          this.TableContent.splice(index, 1);
        }
      });
    },
    handleAvatarSuccess(param) {
      this.imageUrl = URL.createObjectURL(param.file);
      const data = new FormData();
      data.append("file", param.file);
      let that = this;
      let url = "distribution/FileController/uploadFileToFast";
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };

      axios
        .post(url, data, config)
        .then(response => {
          if (response.data.code == 200) {
            that.imageUrl = "";
            response.data.CloseShow = false;
            that.imgArr.push(response.data);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    secondhandleAvatarSuccess(param) {
      this.secondimageUrl = URL.createObjectURL(param.file);
      const data = new FormData();
      data.append("file", param.file);
      let that = this;
      let url = "distribution/FileController/uploadFileToFast";
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      axios
        .post(url, data, config)
        .then(response => {
          if (response.data.code == 200) {
            that.secondimageUrl = "";
            that.imageUrl = "";
            response.data.weights = "";
            response.data.description = "";
            response.data.CloseShow = false;
            that.secondimgArr.push(response.data);

            that.secondimgArr.forEach((val, index) => {
              val.detailShow = false;
              val.weights = index + 1;
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    GoBack() {
      this.$router.push({name: "GoodsList", params: {pageNo: this.pageIndex, pagesize: this.pageSize}});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
  list-style: none;
}

.PaginationStyle {
  float: right;
  margin-top: 8px;
}

.panelTitle {
  padding-left: 15px;
  text-align: left;
}

.ModelPadding {
  margin-top: -30px;
}

.LineSpacing {
  margin-top: 16px;
}

.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}

.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}

.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}

.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}

.TableContent {
  width: calc(100% / 3);
  float: left;
}

.GContentUl {
  list-style: none;
}

.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}

.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}

.InputWidth {
  width: 300px;
}

.labelstyle {
  float: left;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ReceiptTableTitle {
  list-style: none;
  float: left;
  color: #909399;
  padding: 12px 32px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  position: relative;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  width: calc((100% - 200px) / 4);
}

.ReceiptTableContent {
  padding: 12px 32px;
  list-style: none;
  float: left;
  font-size: 14px;
  line-height: 24px;
  height: 68px;
  color: #606266;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;

  width: calc((100% - 200px) / 4);
  border: 1px solid #ebeef5;
}

.imgArrLi {
  float: left;
  width: 300px;
  list-style: none;
  position: relative;
  height: 250px;
}

.EorrorTips {
  font-size: 12px;
  line-height: 20px;
  color: red;
}

@media screen and (min-width: 1200px) and (max-width: 1310px) {
  .InputWidth {
    width: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/AddGoods.vue